import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=0af6e8a0&"
import script from "./FormCreate.vue?vue&type=script&lang=js&"
export * from "./FormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports